module.exports = __webpack_public_path__ + "img/smile.cb6dbce4.svg";